// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file empty.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file empty.proto.
 */
export const file_empty: GenFile = /*@__PURE__*/
  fileDesc("CgtlbXB0eS5wcm90bxILZ3JwYy5hcGkudjEiDgoMRW1wdHlSZXF1ZXN0Ig8KDUVtcHR5UmVzcG9uc2VCBloELjtwYmIGcHJvdG8z");

/**
 * @generated from message grpc.api.v1.EmptyRequest
 */
export type EmptyRequest = Message<"grpc.api.v1.EmptyRequest"> & {
};

/**
 * Describes the message grpc.api.v1.EmptyRequest.
 * Use `create(EmptyRequestSchema)` to create a new message.
 */
export const EmptyRequestSchema: GenMessage<EmptyRequest> = /*@__PURE__*/
  messageDesc(file_empty, 0);

/**
 * @generated from message grpc.api.v1.EmptyResponse
 */
export type EmptyResponse = Message<"grpc.api.v1.EmptyResponse"> & {
};

/**
 * Describes the message grpc.api.v1.EmptyResponse.
 * Use `create(EmptyResponseSchema)` to create a new message.
 */
export const EmptyResponseSchema: GenMessage<EmptyResponse> = /*@__PURE__*/
  messageDesc(file_empty, 1);

